import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { EditLearner, EditLearnerError, EditLearnerSuccess, LoadLearnerDataSuccess, SetEditLearner, SetEditLearnerSuccess } from "./edit-learner.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { LearnerList } from "src/app/_models/LearnerList";
import { LearnerEditDto } from "src/app/_models/LearnerEditDto";

@Injectable()
export class EditLearnerEffects {
  constructor(
    private actions$: Actions,
    private userProfileService: UserProfileService
  ){}

  public editLearnerEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(EditLearner),
      switchMap((dto: { payload: LearnerEditDto }) => 
        this.userProfileService.updateLearnerProfile$(dto.payload).pipe(
          map((result: LearnerList) => {
            return EditLearnerSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(EditLearnerError({error: error}));
          })
        )
      )
    )
  );

  public loadLearnerDataEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetEditLearner),
      switchMap((payload: { data: LearnerList }) => 
        this.userProfileService.getUserProfile$(payload.data?.userProfileId).pipe(
          map((result: Userprofile) => {
            return LoadLearnerDataSuccess({data: result});
          })
        )
      )
    )
  );

  public setLearnerDataSuccessEffect$ =  createEffect(() =>
    this.actions$.pipe( 
      ofType(LoadLearnerDataSuccess),
      map(() => {
        return SetEditLearnerSuccess();
      })
    ),
  );
}